import React from 'react';
import { getTagIcon } from '../utils/helpers';

// Component for displaying chat tags
const ChatTags = ({ tags, onRemove }) => {
  if (!tags || tags.length === 0) return null;

  // Filter out any undefined tags as a safety measure
  const validTags = tags.filter(tag => tag && tag.id && tag.color && tag.name);

  if (validTags.length === 0) return null;

  return (
    <div className="flex items-center gap-1 ml-2">
      {validTags.map((tag) => {
        const IconComponent = getTagIcon(tag.icon);
        return (
          <div
            key={tag.id}
            className="group inline-flex items-center group-hover:gap-1 px-2 py-0.5 rounded-full text-xs font-medium cursor-pointer hover:opacity-80 transition-all duration-200 ease-in-out"
            style={{ 
              backgroundColor: `${tag.color}20`,
              color: tag.color,
              border: `1px solid ${tag.color}40`
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (onRemove) onRemove(tag.id);
            }}
            title={`Remove ${tag.name} tag`}
          >
            <IconComponent className="w-3 h-3 flex-shrink-0" />
            <span className="max-w-0 overflow-hidden whitespace-nowrap group-hover:max-w-xs transition-all duration-200 ease-in-out">
              {tag.name}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default ChatTags; 